<template>
    <div class="app-container" style="padding: 0">
        <el-select class="main-select-tree el-select-width" ref="selectTree" v-model="value" clearable
            @clear="clearSelectInput">
            <el-input v-if="isSearch==1" class="el-search-box" placeholder="输入关键字进行过滤" v-model="filterText" clearable>
            </el-input>
            <el-option v-for="item in formatData(data)" :key="item.value" :label="item.label" :value="item.value"
                style="display: none;" />
            <el-tree class="main-select-el-tree" ref="selecteltree" :data="data" node-key="id" :indent="0"
                highlight-current :props="defaultProps" @node-click="handleNodeClick" :current-node-key="value"
                :expand-on-click-node="false" default-expand-all :filter-node-method="filterNode" />
        </el-select>
    </div>
</template>
<script>

    export default {
        props: {
            isSearch: {
                type: Number,
                default: 1,
            },
            selectValue: {
                type: [String, Number],
                default: null,
            },
            data: {
                type: Array,
                default: () => []
            },
            defaultProps: {
                type: Object,
                required: true
            },
        },
        data() {
            return {
                filterText: "",
                value: this.selectValue,
                // data: [ {
                // id: 1,
                // label: "云南",
                // children: [ {
                // id: 2,
                // label: "昆明",
                // children: [ {
                // id: 3,
                // label: "五华区",
                // children: [ {
                // id: 8,
                // label: "xx街道",
                // children: [ {
                // id: 81,
                // label: "yy社区",
                // children: [{ id: 82, label: "北辰小区" }],
                // },
                // ],
                // },
                // ],
                // },
                // { id: 4, label: "盘龙区" },
                // ],
                // },
                // ],
                // },{
                // id: 5,
                // label: "湖南",
                // children: [
                // { id: 6, label: "长沙" },
                // { id: 7, label: "永州" },
                // ],
                // },{
                // id: 12,
                // label: "重庆",
                // children: [
                // { id: 10, label: "渝北" },
                // { id: 9, label: "合川" },
                // ],
                // },{
                // id: 13,
                // label: "江苏",
                // children: [{ id: 14, label: "盐城" }],
                // },
                // ],
                // defaultProps: {
                // children: "children",
                // label: "label",
                // },
            };
        },
        watch: {
            filterText(val) {
                this.$refs.selecteltree.filter(val);
            },

        },
        methods: {
            filterNode(value, data) {
                if (!value) return true;
                return data.label.indexOf(value) !== -1;
            },
            // 递归遍历数据
            formatData(data) {
                let options = [];
                const formatDataRecursive = (data) => {
                    data.forEach((item) => {
                        options.push({ label: item[this.defaultProps.label], value: item.id });
                        if (item.children && item.children.length > 0) {
                            formatDataRecursive(item.children);
                        }
                    });
                };
                formatDataRecursive(data);
                return options;
            },
            // 点击事件
            handleNodeClick(node) {
                if (!node.children || node.children.length == 0) {
                    this.value = node.id;
                    this.$refs.selectTree.blur();
                    this.$emit('update:selectValue', node.label);
                    this.$emit('update:selectID', node.id);
                    this.$emit('update:selectNode', node);
                }

            },
            // 清空事件
            clearSelectInput() {
                this.$emit('update:selectValue', '');
                // this.$emit('update:selectID', null);
                // 获取 el-tree 实例的引用
                const elTree = this.$refs.selecteltree;
                // 将当前选中的节点设置为 null
                elTree.setCurrentKey(null);
            },
        },
    };
</script>
<style>
    .main-select-el-tree .el-tree-node .is-current>.el-tree-node__content {
        font-weight: bold;
        color: #409eff;
    }

    .main-select-el-tree .el-tree-node.is-current>.el-tree-node__content {
        font-weight: bold;
        color: #409eff;
    }

    .el-select-width {
        width: 240px;
    }

    .el-tree-node__label {
        white-space: pre;
    }
</style>